import { DropdownOptionModel } from './dropdown-option-model';

import {
   PersonalLoanApplicationResponse
} from '../shared/models/index';

import LoanPurpose = PersonalLoanApplicationResponse.LoanPurposeEnum;

export const LOAN_PURPOSE_TYPE_OPTIONS: DropdownOptionModel<LoanPurpose>[] = [
  { value: LoanPurpose.CreditCardRefinancing, display: 'Credit Card Refinancing' },
  { value: LoanPurpose.DebtConsolidation, display: 'Debt Consolidation' },
  { value: LoanPurpose.HomeImprovement, display: 'Home Improvement' },
  { value: LoanPurpose.MajorPurchase, display: 'Major Purchase' },
  { value: LoanPurpose.HomePurchase, display: 'Home Purchase' },
  { value: LoanPurpose.CarFinancing, display: 'Car Financing' },
  { value: LoanPurpose.GreenLoan, display: 'Green Loan' },
  { value: LoanPurpose.Business, display: 'Business' },
  { value: LoanPurpose.Vacation, display: 'Vacation' },
  { value: LoanPurpose.MovingAndRelocation, display: 'Moving And Relocation' },
  { value: LoanPurpose.MedicalExpenses, display: 'Medical Expenses' },
  { value: LoanPurpose.Other, display: 'Other' }
];
